import { FunctionComponent } from 'react';
import { Avatar, Flex, Text } from '@chakra-ui/react';

type TeamCellProps = {
  name: string;
  acronym?: string;
  logoPath?: string;
};

export const TeamCell: FunctionComponent<TeamCellProps> = ({ name, acronym, logoPath }) => (
  <Flex align="center" gap={2}>
    <Avatar
      size="xs"
      name={acronym || name}
      src={logoPath}
      bg="gray.100"
      color="gray.700"
      fontSize="10px"
      fontWeight="bold"
    />
    <Text fontSize="sm" fontWeight="medium" color="gray.700" noOfLines={1}>
      {name}
    </Text>
  </Flex>
);
